import { render, staticRenderFns } from "./ChatComposer.vue?vue&type=template&id=9b20526a&"
import script from "./ChatComposer.vue?vue&type=script&lang=js&"
export * from "./ChatComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports